module.exports = __webpack_public_path__ + "static/Icons_SecondHome_small-2567039ae71fe024276ec589c761e521.png";